import styled from "@emotion/styled";

export const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f6f7;
`;

export const Header = styled.header`
  position: sticky;
  top: 0;
  display: block;
  z-index: 2;
`;

export const Content = styled.main`
  --content-height: calc(
    ${(props: any) => props.windowHeight}px - ${(props: any) => props.headerHeight}px
  );
  display: block;
  width: 100vw;
  height: var(--content-height);
  min-height: 100%;
  overflow: hidden;
  z-index: 1;

  .appWrapper {
    width: 100vw;
    position: relative;
    min-height: calc(var(--content-height) - 110px);

    .center {
      min-height: calc(var(--content-height) - 110px);
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
    }
  }

  label {
    color: #3f4b5f;
    font-family: "Proxima Nova Sbold", sans-serif;
  }

  .ant-select-item,
  .ant-select-item-option,
  .ant-select-item-option-active {
    padding: 16px !important;
    text-transform: uppercase;
    overflow-y: scroll;
  }

  .ant-switch {
    font-family: "Proxima Nova", sans-serif;
  }

  .ant-switch-inner {
    font-size: 16px !important;
  }

  .ant-switch-checked {
    background-color: #345eea !important;
  }

  .ant-checkbox-inner {
    width: 16px !important;
    height: 16px !important;
    border-radius: 2px !important;
  }

  .ant-checkbox-inner::after {
    left: 3px !important;
  }

  .ant-form-item-label {
    margin-bottom: 6px;
  }
`;
